// extracted by mini-css-extract-plugin
export var content = "footer-module--content--oBdRx";
export var legal = "footer-module--legal--kkAeY";
export var legals = "footer-module--legals--DsyvT";
export var logo = "footer-module--logo--Yt86o";
export var logoImg = "footer-module--logoImg--looJl";
export var logoText = "footer-module--logoText--61JLR";
export var nav = "footer-module--nav--V0nMP";
export var navItem = "footer-module--navItem--tO901";
export var navItems = "footer-module--navItems--vog+5";
export var navLink = "footer-module--navLink--6VLmr";
export var root = "footer-module--root--DCNJ6";
export var t4k = "footer-module--t4k--i33aJ";
export var t4kText = "footer-module--t4k-text--T25uh";